import { hasMatchingPushPermission } from "./hasPushPermission";

export const INVOICE_DUE_DATE_PUSH_FUNCTION_KEYS = [
  "alteracao_vencimento",
  "Alteração de Vencimento da Fatura",
] as const;

export const INVOICE_DUE_DATE_SAC_LABEL = "Alterar data de vencimento";
export const INVOICE_DUE_DATE_PUSH_LABEL =
  "Alterar data de vencimento (via App)";
export const INVOICE_DUE_DATE_PUSH_TITLE =
  "Altere o vencimento da sua fatura";
export const INVOICE_DUE_DATE_PUSH_DESCRIPTION =
  "Escolha a melhor data de vencimento para a sua fatura com praticidade e segurança. Toque aqui para acessar o app e alterar agora";
export const INVOICE_DUE_DATE_PUSH_SUCCESS =
  "Link para alterar data de vencimento enviado com sucesso";
export const INVOICE_DUE_DATE_PUSH_JOURNEY = "alteracao_vencimento";

export type InvoiceDueDateActionVisibility = {
  showSacDueDateAction: boolean;
  showPushDueDateAction: boolean;
};

export function getInvoiceDueDateActionVisibility({
  hasChangeDueDatePermission,
  pushChannelEnabled,
  sacChannelEnabled,
}: {
  hasChangeDueDatePermission: boolean;
  pushChannelEnabled: boolean;
  sacChannelEnabled: boolean;
}): InvoiceDueDateActionVisibility {
  if (!hasChangeDueDatePermission) {
    return {
      showSacDueDateAction: false,
      showPushDueDateAction: false,
    };
  }

  return {
    showSacDueDateAction: Boolean(sacChannelEnabled),
    showPushDueDateAction: Boolean(pushChannelEnabled),
  };
}

const hasInvoiceDueDateChannel = (channel: "push" | "sac"): boolean =>
  hasMatchingPushPermission(INVOICE_DUE_DATE_PUSH_FUNCTION_KEYS, channel);

export function resolveInvoiceDueDateActionVisibility(
  permissions?: string[] | null
): InvoiceDueDateActionVisibility {
  return getInvoiceDueDateActionVisibility({
    hasChangeDueDatePermission: Boolean(
      permissions?.includes("change_InvoiceDueDate")
    ),
    pushChannelEnabled: hasInvoiceDueDateChannel("push"),
    sacChannelEnabled: hasInvoiceDueDateChannel("sac"),
  });
}
